export const POST_RATING = 'POST_RATING'
export const POST_RATING_SUCCESS = 'POST_RATING_SUCCESS'
export const POST_RATING_ERROR = 'POST_RATING_ERROR'
